var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 669,
    height: 288,
    viewBox: "0 0 669 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_12764",
    "data-name": "Rettangolo 12764",
    width: 556,
    height: 262,
    transform: "translate(0.001 0)",
    fill: "#e5e5e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23029",
    "data-name": "Raggruppa 23029",
    transform: "translate(-416 -1640)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23025",
    "data-name": "Raggruppa 23025",
    transform: "translate(-6 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22560",
    "data-name": "Raggruppa 22560",
    transform: "translate(-63 23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22295",
    "data-name": "Raggruppa 22295",
    transform: "translate(533.999 1616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22295-2",
    "data-name": "Raggruppa 22295",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33341",
    "data-name": "Tracciato 33341",
    d: "M291.038,539.012a266.729,266.729,0,0,1-66.77-8.467l32.106-124.109a139.169,139.169,0,0,0,75.613-1.788L370.01,527.076a265.989,265.989,0,0,1-78.972,11.937M204.03,524.438A266.03,266.03,0,0,1,84.6,440.768l99.452-80.892a137.922,137.922,0,0,0,61.9,43.413ZM389.93,520,342.254,401a138.132,138.132,0,0,0,59.8-46.318l103.168,76.094A266.217,266.217,0,0,1,389.93,520M71.951,423.9A265.177,265.177,0,0,1,25.327,285.622l128.055-6a137.107,137.107,0,0,0,24.1,71.5Zm445.11-10.584L408.195,345.627a137.37,137.37,0,0,0,20.654-72.621h128.2a265.455,265.455,0,0,1-39.983,140.313m-88.23-142.53a137.254,137.254,0,0,0-21.808-72.255L514.8,129.124a265.328,265.328,0,0,1,42.209,139.668ZM153.3,268.6,25.163,264.607A265.243,265.243,0,0,1,69.584,125.6L176.25,196.708A137.182,137.182,0,0,0,153.3,268.6m247.442-79.025a138.057,138.057,0,0,0-60.516-45.362L385.988,24.464a266.15,266.15,0,0,1,116.707,87.4Zm-218.057-1.731L81.967,108.529a266.1,266.1,0,0,1,118.07-85.537l43.854,120.461a138,138,0,0,0-61.21,44.391M329.9,140.734a139.173,139.173,0,0,0-75.633-.595L220.174,16.56a267.361,267.361,0,0,1,145.782,1.153Z",
    transform: "translate(-4.943 -1.391)",
    fill: "#e5e5e5"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "TGM",
    transform: "translate(422 1823)",
    fontSize: 16,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40,
    y: 15
  }, "TGM")), /*#__PURE__*/React.createElement("text", {
    id: "Difettosit\\xE0_Struttura",
    "data-name": "Difettosit\\xE0 Struttura",
    transform: "translate(579 1660)",
    fontSize: 16,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40,
    y: 0
  }, "Difettosit\xE0"), /*#__PURE__*/React.createElement("tspan", {
    x: -34,
    y: 16
  }, "Struttura")), /*#__PURE__*/React.createElement("text", {
    id: "Fondazioni",
    transform: "translate(755 1628)",
    fontSize: 16,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40,
    y: 0
  }, "Fondazioni")), /*#__PURE__*/React.createElement("text", {
    id: "Instabilit\\xE0_Versante",
    "data-name": "Instabilit\\xE0 Versante",
    transform: "translate(1053 1828)",
    fontSize: 16,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -37,
    y: 0
  }, "Instabilit\xE0"), /*#__PURE__*/React.createElement("tspan", {
    x: -33,
    y: 16
  }, "Versante")), /*#__PURE__*/React.createElement("text", {
    id: "Resilienza_Idraulica",
    "data-name": "Resilienza Idraulica",
    transform: "translate(947 1660)",
    fontSize: 16,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -37,
    y: 0
  }, "Resilienza"), /*#__PURE__*/React.createElement("tspan", {
    x: -31,
    y: 16
  }, "Idraulica"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph1);
export default __webpack_public_path__ + "static/media/graph1.cd11132c67d113f51f8b4c6b52db7412.svg";
export { ForwardRef as ReactComponent };